import { Component, Input} from "@angular/core";
import { SharedModule } from "../../helper/shared.module";

@Component({
    selector: 'ig-count-label',
    template: '<span class="ig-count-label">{{ label }}</span>',
    styleUrls: ['./count-label.component.scss'],
    imports: [SharedModule]
})
export class CountLabelComponent {
  /**
   * The label for the count label
   */
  @Input({ required: true }) label!: string;

}
